import { render } from "./MasterCardAboveForm.vue?vue&type=template&id=aded5c10"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__